var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.975 18.8047L10.675 12.5047C10.175 12.9047 9.6 13.2214 8.95 13.4547C8.3 13.688 7.60833 13.8047 6.875 13.8047C5.05833 13.8047 3.52083 13.1755 2.2625 11.9172C1.00417 10.6589 0.375 9.12135 0.375 7.30469C0.375 5.48802 1.00417 3.95052 2.2625 2.69219C3.52083 1.43385 5.05833 0.804688 6.875 0.804688C8.69167 0.804688 10.2292 1.43385 11.4875 2.69219C12.7458 3.95052 13.375 5.48802 13.375 7.30469C13.375 8.03802 13.2583 8.72969 13.025 9.37969C12.7917 10.0297 12.475 10.6047 12.075 11.1047L18.375 17.4047L16.975 18.8047ZM6.875 11.8047C8.125 11.8047 9.1875 11.3672 10.0625 10.4922C10.9375 9.61719 11.375 8.55469 11.375 7.30469C11.375 6.05469 10.9375 4.99219 10.0625 4.11719C9.1875 3.24219 8.125 2.80469 6.875 2.80469C5.625 2.80469 4.5625 3.24219 3.6875 4.11719C2.8125 4.99219 2.375 6.05469 2.375 7.30469C2.375 8.55469 2.8125 9.61719 3.6875 10.4922C4.5625 11.3672 5.625 11.8047 6.875 11.8047Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.f4ac7bdac38d8817104f2c0f0081ff5c.svg";
export { ForwardRef as ReactComponent };